<template>
  <div class="relative pt-6 sm:p-6 my-1">
    <div class="flex justify-between items-center">
      <h1 class="text-xl font-semibold leading-6 text-gray-900">
        Building Amenities
      </h1>
      <RequiredToSavePublish />
    </div>
    <section class="mt-6">
      <AmenitiesList :amenities="amenities" />
    </section>
    <section class="w-full mt-5">
      <label class="font-semibold my-5">Tag</label>
      <TagsInput
        v-if="editable"
        data-testid="editing"
        :model-value="getEditingTags"
        :options="categories"
        label="name"
        @update:model-value="updateTags"
      />
      <div v-else>
        <p class="font-normal">
          {{ editingTagsNames }}
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapActions, mapGetters } from "vuex";
import RequiredToSavePublish from "../RequiredToSavePublish/index.vue";
import TagsInput from "@/components/shared/TagsInput.vue";
import AmenitiesList from "./AmenitiesList.vue";
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default {
  name: "BuildingAmenitiesTab",
  components: { RequiredToSavePublish, TagsInput, AmenitiesList },
  inject: ["provideEdit"],
  props: {
    originalHousingRecord: {
      type: Object,
      required: true,
    },
    amenities: {
      type: Object,
      required: true,
    },
    tags: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      v$: useVuelidate({
        $registerAs: "BuildingAmenitiesTab",
        $lazy: true,
        $autoDirty: true,
      }),
    };
  },
  data() {
    return {
      housingUpdates: {
        tags: this.originalHousingRecord.tags?.map((tag) => tag.id),
      },
    };
  },
  computed: {
    ...mapGetters("programManager", ["getCurrentEditingTags"]),
    getEditingTags() {
      return cloneDeep(this.getCurrentEditingTags);
    },
    editingTagsNames() {
      return this.getEditingTags.map((tag) => tag.name).join(", ");
    },
    editable() {
      return this.provideEdit();
    },
    categories() {
      return this.tags.getFlatCategoryTags.value;
    },
  },
  watch: {
    "originalHousingRecord.tags": {
      handler: function () {
        this.housingUpdates.tags = this.originalHousingRecord?.tags.map(
          (tag) => tag.id
        );
      },
    },
  },
  validations: {
    getCurrentEditingTags: {
      required: requiredIf(() => false),
    },
  },
  methods: {
    getUpdates() {
      return { updates: this.housingUpdates };
    },
    updateTags(tags) {
      this.setCurrentEditingTags(cloneDeep(tags));
    },
    ...mapActions("programManager", ["setCurrentEditingTags"]),
  },
};
</script>
